import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { useSetActivityRoundMutation } from '~/redux/apis/user-stats-api'

interface ReturnType {
  onContinueActivity: (activityPath: string) => void
  onRetakeActivity: (activityPath: string) => void
}

export default function useRetakeActivity(locale: string | undefined): ReturnType {
  const router = useRouter()
  const [setRetakeActivityRound] = useSetActivityRoundMutation()

  const onContinueActivity = useCallback(
    (activityPath: string): void => {
      router.push(activityPath, activityPath, { locale })
    },
    [locale, router],
  )

  const onRetakeActivity = useCallback(
    async (activityPath: string): Promise<void> => {
      await setRetakeActivityRound({
        activityPath,
        start: true,
        product: 'bootcamp',
      })
      onContinueActivity(activityPath)
    },
    [onContinueActivity, setRetakeActivityRound],
  )

  return {
    onContinueActivity,
    onRetakeActivity,
  }
}
